import {
  ShiftManagementRefreshLeavesDocument,
  ShiftsLeaveFragment,
  ShiftsShiftFragment,
} from 'generated/resources/graphql'

import { useLazyQuery } from 'modules/core/hooks/useQuery'

import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useShiftsRows } from 'modules/shift_management/hooks/useShiftsRows'
import { ShiftsRow } from 'modules/shift_management/lib/types'
import Leave from 'modules/shift_management/store/internal/models/Leave'
import Shift from 'modules/shift_management/store/internal/models/Shift'

const useRefreshLeaves = () => {
  const [{ view }] = useSchedule()
  const [, dispatchShiftsRows] = useShiftsRows()
  const [refreshLeavesQuery] = useLazyQuery(ShiftManagementRefreshLeavesDocument)
  const { startAt, endAt } = view

  const refreshLeaves = async (shiftsRows: ShiftsRow[]) => {
    const { data } = await refreshLeavesQuery({
      variables: {
        employeeIds: shiftsRows.flatMap((row: ShiftsRow) => row.employeeIds),
        endAt,
        startAt,
      },
    })

    const nodes = data?.shiftManagement.employeesPermissionsConnection.nodes || []

    const leaves = nodes.flatMap((node) => {
      return node.leaves.map((leave: ShiftsLeaveFragment) =>
        Leave.buildFromGraphQL(leave, node.avatar?.url || '', node.fullName)
      )
    })

    const shifts = nodes.flatMap((node) => {
      return node.shifts.map((shift: ShiftsShiftFragment) =>
        Shift.buildFromGraphQL({
          shift,
          employeeFullName: node.fullName,
          employeeAvatar: node.avatar?.url || '',
          employeeLocationId: node.locationId || null,
        })
      )
    })

    dispatchShiftsRows({
      type: 'RESET_LEAVES',
      leaves,
    })

    // To update shifts in any case there is backup shifts overlapping with leaves.
    dispatchShiftsRows({
      type: 'RESET_SHIFTS',
      shifts,
      view,
    })
  }

  return { refreshLeaves }
}

export default useRefreshLeaves
